import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
export const inputComponent = _ref => {
  let {
    inputRef
  } = _ref,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: inputRef
  }, props));
};